import { PageContainerStyled } from './page-container.styled';

export interface PageContainerProps {
  isHamburgerClicked: boolean;
  children: any;
}
const PageContainer = (props: PageContainerProps) => {

  return (
    <PageContainerStyled.Container xs={12} md={10} item>
      {props.children}
    </PageContainerStyled.Container>
  );
};

export default PageContainer;
